import { PageActionType } from './page-action-type';
import { castArray } from 'lodash';

export interface LoadPageErrorAction {
  errors: Error[];
  pageKey: string;
  type: PageActionType.LoadPageError;
}

export const loadPageError = (
  pageKey: string,
  errors: Error | readonly Error[],
): LoadPageErrorAction => ({
  errors: castArray(errors),
  pageKey,
  type: PageActionType.LoadPageError,
});
